<tn-dialog-shell testId="info" [title]="''" [ariaLabel]="data.title | translate">
  <h1 class="information-header">
    <tn-icon class="information-icon" library="mdi" [name]="data.icon || 'information'"></tn-icon>
    <span class="information-title" tnTestId="info-title" tnTestIdType="text">{{ data.title | translate }}</span>
  </h1>
  @if (data.isHtml) {
    <div class="info-panel ip-overflow-auto">
      <span tnTestId="info-message" tnTestIdType="text" [innerHtml]="data.info | translate"></span>
    </div>
  } @else {
    <div class="info-panel">
      <div class="textarea" tnTestId="info-message" tnTestIdType="text">{{ data.info | translate }}</div>
    </div>
  }

  <div tnDialogAction>
    <tn-button
      testId="dialog-close"
      [label]="'Close' | translate"
      (onClick)="dialogRef.close(true)"
    ></tn-button>
  </div>
</tn-dialog-shell>
